<template>
  <div>
    <div class="load-more-tickets">
      &nbsp;&nbsp;
      <span class="btn btn-sm btn-outline-success" href="#" data-target="#crearTareaModal" data-toggle="modal"><span>Nueva
          Tarea</span></span>&nbsp;&nbsp;
      <span class="btn btn-sm btn-outline-dark" href="#" data-toggle="modal" @click="verReqsXCategoria()"><span>Ver reqs
          pendientes</span></span>&nbsp;&nbsp;
      <span class="btn btn-sm btn-outline-info" href="#" data-toggle="modal" @click="verInventarioDePosicion()"><span>Inv.
          en posición</span></span>
      <ExistenciasModalComponent />
    </div>
    <br>
    <div class="modal fade" id="crearTareaModal" role="dialog" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Crear Tarea</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true"> ×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label v-bind:class="{
                    'text-danger': current.errors && current.errors.tienda,
                  }">
                    Tienda Origen
                  </label>
                  <select class="form-control" autofocus="autofocus" v-model="current.tienda_origen" @change="refreshCola"
                    :disabled="current.id != null">
                    <option v-for="(tienda, key) in tiendas" :value="tienda.codigo" :key="key">
                      {{ tienda.codigo }}
                      -
                      {{ tienda.nombre }}
                    </option>
                  </select>
                  <small v-if="current.errors && current.errors.tienda_origen" class="form-text text-danger">{{
                    current.errors.tienda_origen[0]
                  }}</small>
                </div>
                <TiendaSelectComponent titulo="Tienda Destino" :current="current" @change="refreshCola" />
                <small v-if="error_tarea" class="form-text text-danger">
                  {{ error_tarea }}
                </small>
                <br />
                <button @click="crearTareaSubmit()" class="btn btn-block btn-primary" type="submit">
                  Aceptar
                </button>
              </div>
              <div class="col-md-6">
                <table class="table table-padded">
                  <thead>
                    <tr>
                      <th>Usuario</th>
                      <th>Turno</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="cola in listado_cola" :class="{ 'cola-me': cola.me }">
                      <td>
                        <div class="user-with-avatar">
                          <img alt="" :src="cola.usuario__image_url" />
                          <span>{{ cola.usuario__username }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="smaller lighter text-center">
                          <h3>{{ cola.turno }}</h3>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="reqPendienteXcategoria" role="dialog" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <span style="font-size: 15px" class="text-success text-center">Reqs pendientes por categoría</span>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="text-center"></div>
            <div class="table-responsive" v-if="reqs_pendientes && reqs_pendientes[0]">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th colspan="2" class="text-center">Rutas</th>
                    <th colspan="3" class="text-center">Categorías</th>
                  </tr>
                  <tr>
                    <th class="text-center">Tienda origen</th>
                    <th class="text-center">Tienda Destino</th>
                    <th class="text-center">A</th>
                    <th class="text-center">B</th>
                    <th class="text-center">C</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="detalle in reqs_pendientes" v-bind:key="detalle">
                    <td class="text-center text-dark">
                      {{ detalle.tienda_pedir_id }}
                    </td>
                    <td class="text-center text-dark">
                      {{ detalle.tienda_id }}
                    </td>
                    <td class="text-center" style="color: #11b301">
                      {{ detalle.A }}
                    </td>
                    <td class="text-center" style="color: #067efe">
                      {{ detalle.B }}
                    </td>
                    <td class="text-right" style="color: #d67100">
                      {{ detalle.C }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-------------------- END - Basic Table -------------------->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.cola-me td {
  background-color: rgba(17, 179, 1, 0.07) !important;
}
</style>

<script>
import { mapGetters } from "vuex";
import DynamicService from "@/services/commons/DynamicService";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ExistenciasModalComponent from "@/components/commons/ExistenciasModalComponent";

export default {
  components: {
    TiendaSelectComponent,
    ExistenciasModalComponent,
  },
  props: {
    id_tarea: {
      type: String,
    },
  },
  data() {
    return {
      interval_cola: null,
      reqs_pendientes: [],
      current: {
        tienda_origen: "02",
        tienda: null,
        errors: {},
      },
      listado_cola: [],
      error_tarea: null,
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    $("#asignarCarrito").on("shown.bs.modal", function () {
      $("#barra_carrito").trigger("focus");
    });
    // this.refreshCola();
  },
  methods: {
    verInventarioDePosicion() {
      $("#modalOpciones").modal("hide");
      $("#modalBarraPosicion").modal("show");
    },
    verReqsXCategoria() {
      let self = this;
      DynamicService.getActionList(
        "wms",
        "tareas",
        "obtener_reqs_x_categoria_abc"
      ).then((response) => {
        self.reqs_pendientes = response.data;
        $("#reqPendienteXcategoria").modal("show");
      });
    },
    refreshCola() {
      let self = this;
      let tienda_origen = self.current.tienda_origen;
      let tienda_destino = self.current.tienda;
      DynamicService.getActionList("wms", "tareas", "cola_de_tareas", {
        tienda_origen: tienda_origen,
        tienda_destino: tienda_destino,
        loading: false,
      }).then((response) => {
        self.listado_cola = response.data;
      });
    },
    crearTareaSubmit() {
      let self = this;
      self.error_tarea = null;
      self.interval_cola = setInterval(() => {
        self.refreshCola();
      }, 2000);
      DynamicService.postActionList("wms", "tareas", "crear_tarea_con_cola", {
        tienda_origen: self.current.tienda_origen,
        tienda_destino: self.current.tienda,
      })
        .then((res) => {
          $("#crearTareaModal").modal("hide");
          clearInterval(self.interval_cola);
          self.$emit("refresh");
        })
        .catch((err) => {
          if (err.response.data.tarea) {
            self.error_tarea = err.response.data.tarea;
          }
          clearInterval(self.interval_cola);
        });
    },
  },
};
</script>
